import { jsx as _jsx } from "react/jsx-runtime";
import { TagBase } from '../TagBase';
import { TagLink } from '../TagLink';
export function isTagLinkProps(props) {
    return 'href' in props && props.href !== undefined;
}
export function Tag(props) {
    if (isTagLinkProps(props)) {
        return _jsx(TagLink, Object.assign({}, props));
    }
    return _jsx(TagBase, Object.assign({}, props));
}
